import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { prettyMatchUrl, teamNameLabel } from '../../common/rcs_gaz_mc_core_FE';
import { BasketMatchRowWrapper } from './styles';
import LocalStorageUtility from '../../common/localStorageUtility/localStorageUtility';
import PreferredStar from '../PreferredStar';
import TeamLabel from '../TeamLabel';
import IconFont from '../shared/IconFont';
import ConfigManager from '../../common/configManager/configManager';
import * as status from '../../constants/';
import Label from '../shared/Label';
import BasketTiming from '../TimeResults/BasketTiming';

const BasketMatchRow = ({
  matchRow, isMobile, sportId, actions, date, showRowScorer, dictionary, competitionId,
}) => {
  const basketTeamsUrl = ConfigManager.getBasketTeams('min');
  const handleFavourites = () => {
    if (!showRowScorer) {
      if (!LocalStorageUtility.isPreferred(matchRow.get('matchId'))) {
        actions.showTooltip();
        setTimeout(() => {
          actions.hideTooltip();
        }, 2500);
      }
      actions.favouriteGame(sportId, matchRow.get('matchId'));
      actions.setFavouritesOnCompetition(matchRow.get('matchId'));
    } else {
      actions.removefavouriteGame(sportId, matchRow.get('matchId'), date);
    }
  };

  const isHomeWinner = () => (Number(matchRow.getIn(['teamHome', 'scores', 'total'])))
    > (Number(matchRow.getIn(['teamAway', 'scores', 'total']))) && matchRow.get('status') !== status.PLAYING;
  const isAwayWinner = () => (Number(matchRow.getIn(['teamHome', 'scores', 'total'])))
    < (Number(matchRow.getIn(['teamAway', 'scores', 'total']))) && matchRow.get('status') !== status.PLAYING;
  const isLive = () => (matchRow.get('status') === status.PLAYING);

  const parseTeamName = (team) => {
    const teamName = team.get('italianName') || team.get('name');
    return teamNameLabel(teamName);
  };

  return (
    <BasketMatchRowWrapper
      href={prettyMatchUrl(matchRow.getIn(['teamHome', 'name']), matchRow.getIn(['teamAway', 'name']), matchRow.get('matchId'), sportId, competitionId, process.env.REACT_APP_SITE)}
    >
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
      }}
      >
        <Col
          onClick={event => event.preventDefault()}
          md={1}
          sm={1}
          xs={1}
          style={{
            top: isMobile ? '-15px' : '',
            paddingLeft: isMobile ? '10px' : '15px',
            paddingRight: isMobile ? '0px' : '10px',
          }}
        >
          <PreferredStar handleFavourites={handleFavourites} isSelected={matchRow.get('favourite')} />
        </Col>
        {isMobile &&
          <Col sm={5.9} xs={5.9} style={{ paddingRight: 0 }}>
            <TeamLabel
              label={parseTeamName(matchRow.get('teamHome'))}
              color="black"
              image={`${basketTeamsUrl}${matchRow.getIn(['teamHome', 'teamId'])}.png`}
              marginLeft={0.4}
              font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
            <TeamLabel
              label={parseTeamName(matchRow.get('teamAway'))}
              color="black"
              image={`${basketTeamsUrl}${matchRow.getIn(['teamAway', 'teamId'])}.png`}
              marginLeft={0.4}
              font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
          </Col>
        }
        {!isMobile &&
          <Col md={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <TeamLabel
              label={parseTeamName(matchRow.get('teamHome'))}
              color="black"
              image={`${basketTeamsUrl}${matchRow.getIn(['teamHome', 'teamId'])}.png`}
              marginLeft={0.5}
              font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
          </Col>
        }
        {!isMobile &&
          <Col md={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <TeamLabel
              label={parseTeamName(matchRow.get('teamAway'))}
              color="black"
              image={`${basketTeamsUrl}${matchRow.getIn(['teamAway', 'teamId'])}.png`}
              marginLeft={0.5}
              font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
          </Col>
        }
        <Col
          lg={1.55}
          md={1.45}
          sm={1.45}
          xs={1.45}
          style={{
            paddingLeft: 0,
            paddingRight: isMobile ? '0px' : '0px',
            overflow: 'visible',
            justifyContent: 'flex-end',
            display: 'flex',
          }}
        >
          <BasketTiming
            status={matchRow.get('status')}
            isMobile={isMobile}
            timing={matchRow.get('timing')}
            date={matchRow.get('utcDate')}
            isLive={isLive()}
            dictionary={dictionary}
            competitionId={competitionId}
            actions={actions}
          />
        </Col>
        <Col
          md={2.2}
          sm={2.2}
          xs={2.2}
          style={{
            paddingRight: 0,
            paddingLeft: isMobile ? '0px' : '10px',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-evenly',
          }}
        >
          <Label
            label={(matchRow.get('status') !== status.FIXTURE && matchRow.getIn(['teamHome', 'scores', 'total'])) ?
              matchRow.getIn(['teamHome', 'scores', 'total']) : '-'}
            color={isLive() ? 'liveColor' : 'black'}
            margin={isMobile ? '0.8em' : '0.6em'}
            size={isMobile ? 0.85 : 1}
            lineHeight={1}
            isTitleNarrowMedium={isHomeWinner()}
          />
          <Label
            label={(matchRow.get('status') !== status.FIXTURE && matchRow.getIn(['teamAway', 'scores', 'total'])) ?
              matchRow.getIn(['teamAway', 'scores', 'total']) : '-'}
            color={isLive() ? 'liveColor' : 'black'}
            margin={isMobile ? '0.8em' : '0.6em'}
            size={isMobile ? 0.85 : 1}
            lineHeight={1}
            isTitleNarrowMedium={isAwayWinner()}
          />
        </Col>
        <Col
          lg={1.25}
          md={1.45}
          sm={1.45}
          xs={1.45}
          style={{
            display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', paddingRight: '10px', paddingLeft: isMobile ? '0' : '15px',
          }}
        >
          <IconFont
            className="icon-matchcenter-right-arrow"
            color="selectedColor"
            font={18}
            weight="bold"
            withCursor
          />
        </Col>
      </Row>
    </BasketMatchRowWrapper>
  );
};

BasketMatchRow.propTypes = {
  matchRow: PropTypes.any,
  isMobile: PropTypes.any,
  sportId: PropTypes.any,
  actions: PropTypes.any,
  date: PropTypes.any,
  showRowScorer: PropTypes.bool,
  dictionary: PropTypes.any,
  competitionId: PropTypes.any,
};

export default BasketMatchRow;
